import angular from 'angular';
import uiRouter from 'angular-ui-router';
import meComponent from './me.component';

let meModule = angular.module('me', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('me', {
      url: '/me',
      component: 'me',
    });
})

.component('me', meComponent)

.name;

export default meModule;



// WEBPACK FOOTER //
// ./client/app/components/me/me.js